export default {
  name: 'React编写',
  position: '求职目标： Web前端工程师',
  infos: [
    { icon: 'dianhua', value: '12345678910' },
    { icon: 'dianziyoujian', value: 'daffahd22@qq.com' },
    { icon: 'xueli', value: '五道口职业技术学院（本科）' },
    { icon: 'jisuanjishuiping', value: '计算机科学与技术' },
  ],
  leftExps: [
    {
      title: '专业技能',
      values: [
        {
          introduce: [
            '熟悉HTML,JS,CSS,熟悉ES5，了解ES6，熟悉Vue开发，了解其核心原理',
            '熟悉常用的数据结构;熟悉计算机网络,操作系统等;',
            '了解Node，有后端开发经验，熟悉MySql,了解Redis，MongoDB',
          ],
        },
      ],
    },
    {
      title: '校园经历',
      values: [
        {
          des: ['2018.09 – 2022.06', '五道口职业技术学院(本科)', '软件工程'],
          introduce: [
            '担任(加入)xx实验室/团队 （职称），负责了实验室门户网站的维护，带领团队成员参加了xx大赛，获得xx荣誉',
            '担任xxx，负责了xxx工作，收获了XX技能（如Adobe系列）',
          ],
        },
        {
          des: ['2018.09 – 2022.06', '五道口职业技术学院(本科)', '软件工程'],
          introduce: [
            '担任(加入)xx实验室/团队 （职称），负责了实验室门户网站的维护，带领团队成员参加了xx大赛，获得xx荣誉',
            '担任xxx，负责了xxx工作，收获了XX技能（如Adobe系列）',
          ],
        },
      ],
    },
    {
      title: '实习经历',
      values: [
        {
          des: ['2019.12 – 2020.3', '美团', 'Web前端工程师'],
          introduce: [
            '参与XX项目的研发，解决了xx难题',
            '开发了xx插件/工具，解决了xx问题，提升了xx效率',
          ],
        },
      ],
    },
    {
      title: '项目经验',
      values: [
        {
          des: ['上天入地 - 校园二手交易平台', 'github.com/ATQQ/resume'],
          introduce: [
            '现有的xx方式处理xxx情况存在xx问题',
            '前端部分使用Vue，服务端使用Node/TS/MySQL',
          ],
        },
        {
          des: ['天地玄黄', '这里可以放生成的短链'],
          introduce: [
            '简介：校园二手交易平台',
            '难点：图片压缩，大量图片加载，级联选择组件',
            '技术栈：Vue/express/typescript/mysql/TS/MySQL',
          ],
        },
        {
          des: ['阿巴阿巴', 'www.baidu.com'],
          introduce: [
            '参与二手交易平台的前端建设，服务端开发，数据库设计',
            '使用跨端开发框架xx,开发了web，小程序，app等多端应用',
            'xxxxxdadaddad特色',
          ],
        },
      ],
    },
    {
      title: '开源项目',
      values: [
        {
          des: ['xx Vs Code插件', '超链接'],
          introduce: [
            '简介：图床xxx',
            '难点：图片压缩，大量图片加载，级联选择组件',
            '技术栈：Vue/express/typescript/mysql/TS/MySQL',
          ],
        },
      ],
    },
  ],
  rightExps: [
    {
      title: '获奖荣誉',
      values: [
        {
          des: ['2020-11', '国家奖学金'],
        },
        {
          des: ['2020-10', '国家励志奖学金'],
        },
        {
          des: ['2020-9', 'XX大赛金牌'],
        },
      ],
    },
    {
      title: '兴趣爱好',
      values: [
        {
          des: ['篮球', '足球', '吉他', '阿巴阿巴'],
        },
      ],
    },
    {
      title: '个人站点',
      values: [
        {
          des: ['掘金', '粥里有勺糖'],
        },
        {
          des: ['CSDN', '粥里有勺糖'],
        },
        {
          des: ['博客园', '粥里有勺糖'],
        },
      ],
    },
    {
      title: '自我评价',
      values: [
        {
          introduce: [
            '丰富实习经验，热爱互联网',
            '学习能力强，责任感强烈，能承受压力及时完成任务',
            '熟悉小程序，h5开发，有上线产品开发经验',
            '阅读过Vue源码，了解其核心原理',
          ],
        },
      ],
    },
  ],
}
